<div class="page-wrap">
  <div class="order-card-panel">
    <div class="check-circle"><i class="fa-solid fa-check"></i></div>
    <h4 class="thank-you-title">Thank You! Your Quote Request Has Been Placed.</h4>
    <p class="thank-you-sub">We have received your quote request and our team will review it shortly.<br/> A sales representative will contact you with quote details.</p>
    <div class="row g-3 mb-3">
      <div class="col-6 info-box-spacing">
        <div class="info-box">
          <div class="info-label">Request Number</div>
          <div class="info-value">{{ orderConfirmationData?.quoteNo }}</div>
        </div>
      </div>
      <div class="col-6 info-box-spacing">
        <div class="info-box">
          <div class="info-label">Request Date</div>
          <div class="info-value">{{ formatRequestDate(orderConfirmationData?.quoteValidFrom) }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="order-card-panel">
    <div class="section-title">Shipping Address</div>
    <div class="row mb-2">
      <div class="col-md-4">
        <div class="field-label">Job Site Name</div>
        <div class="field-value">{{ orderConfirmationData?.companyName !== "" ? orderConfirmationData?.companyName : '-' }}</div>
      </div>
      <div class="col-md-4">
        <div class="field-label">Job Address</div>
        <div class="field-value">{{ orderConfirmationData?.deliveryAddress?.line1 }}{{ orderConfirmationData?.deliveryAddress?.line1 && (orderConfirmationData?.deliveryAddress?.line2 || orderConfirmationData?.deliveryAddress?.town || orderConfirmationData?.deliveryAddress?.region?.name || orderConfirmationData?.deliveryAddress?.postalCode || orderConfirmationData?.deliveryAddress?.country?.name) ? ', ' : '' }}{{ orderConfirmationData?.deliveryAddress?.line2 }}{{ orderConfirmationData?.deliveryAddress?.line2 && (orderConfirmationData?.deliveryAddress?.town || orderConfirmationData?.deliveryAddress?.region?.name || orderConfirmationData?.deliveryAddress?.postalCode || orderConfirmationData?.deliveryAddress?.country?.name) ? ', ' : '' }}{{ orderConfirmationData?.deliveryAddress?.town }}{{ orderConfirmationData?.deliveryAddress?.town && (orderConfirmationData?.deliveryAddress?.region?.name || orderConfirmationData?.deliveryAddress?.postalCode || orderConfirmationData?.deliveryAddress?.country?.name) ? ', ' : '' }}{{ orderConfirmationData?.deliveryAddress?.region?.name }}{{ orderConfirmationData?.deliveryAddress?.region?.name && (orderConfirmationData?.deliveryAddress?.postalCode || orderConfirmationData?.deliveryAddress?.country?.name) ? ', ' : '' }}{{ orderConfirmationData?.deliveryAddress?.postalCode }}{{ orderConfirmationData?.deliveryAddress?.postalCode && orderConfirmationData?.deliveryAddress?.country?.name ? ', ' : '' }}{{ orderConfirmationData?.deliveryAddress?.country?.name }}</div>
        <div class="field-label">Phone</div>
        <div class="field-value">{{ getFormattedPhone() }}</div>
      </div>
      <div class="col-md-4">
        <div class="field-label">Multiple Shipment</div>
        <div class="field-value">{{ orderConfirmationData?.multiShipment?'Yes':'No' }}</div>
      </div>
      </div>
  </div>
  <div class="order-card-panel">
    <div class="section-title">Additional Information</div>
    <div class="row mb-2 additional-info-grid">
      <div class="col-md-6 additional-info-col">
        <div class="field-label">Shipment Notes / Comments</div>
        <div class="field-value mb-0">{{ orderConfirmationData?.requestQuoteNotes || 'No comments provided.' }}</div>
      </div>
      <div class="col-md-6 additional-info-col">
        <div class="field-label">Uploaded Files</div>
        @if (getUploadedFiles().length > 0) {
          <div class="uploaded-files-list">
            @for (file of getUploadedFiles(); track $index) {
              <div class="uploaded-file-item" [title]="file?.name || file?.fileName || file?.documentName || file">
                {{ file?.name || file?.fileName || file?.documentName || file }}
                @if (file?.sizeLabel || file?.formattedSize || file?.fileSize) {
                  <span class="file-size">({{ file?.sizeLabel || file?.formattedSize || file?.fileSize }})</span>
                }
              </div>
            }
          </div>
        } @else {
          <div class="field-value mb-0">No</div>
        }
      </div>
    </div>
  </div>

  <div class="order-card-panel">
    <div class="section-title">Products Ordered</div>
    <div class="table-responsive">
      <table class="products-table">
        <thead>
          <tr>
            <th>Product</th>
            <th class="table-col">Material#</th>
            <th class="table-col">Qty</th>
            <th class="table-col">Sales Unit</th>
            <th class="table-col">Unit Price</th>
            <th class="table-col">Total Price</th>
            <th>Item Comments</th>
          </tr>
        </thead>
        <tbody>
          @for (item of orderConfirmationData?.entries; track item.entryNumber) {
          <tr>
            <td data-label="Product">
              <div class="product-cell">
                <div class="product-thumb" aria-hidden="true">
                  @if (resolveImageUrl(item)) {
                    <img [src]="resolveImageUrl(item)" [alt]="item.product?.name || item.product?.code" loading="lazy" />
                  } @else {
                    <cx-media [container]="item.product?.images?.PRIMARY" [format]="'cartIcon'"
                      [alt]="item.product?.name || item.product?.code">
                    </cx-media>
                  }
                </div>
                <div class="product-name">
                  {{ item.product?.name }}
                </div>
              </div>
            </td>
            <td data-label="P/N" class="table-col">{{ item.product?.code }}</td>
            <td data-label="Qty" class="table-col">
              {{ item.quantity }}
            </td>
            <td data-label="Sales Unit" class="table-col">{{ item.uom }}</td>
            <td data-label="Unit Price" class="table-col">{{ item?.knbrTotalPrice?.netPrice === 0 ? 'Quoted' : item?.knbrTotalPrice?.formatedNetPrice }}</td>
            <td data-label="Total Price" class="table-col">{{ item?.totalPrice?.value === 0 ? 'Quoted' : item?.totalPrice?.formattedValue }}</td>
            <td data-label="Item Comments">
              {{ item.entryNote }}
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="table-totals-row">
      <div class="table-total-item">Total Items: <span>{{ orderConfirmationData?.totalItems || 0 }}</span></div>
      <div class="table-total-item">Total Quantity: <span>{{ orderConfirmationData?.totalUnitCount || 0 }}</span></div>
      <div class="table-total-item">Total Price (Est.): <span>{{ orderConfirmationData?.totalPrice?.value === 0 ? 'Quoted' : orderConfirmationData?.totalPrice?.formattedValue}}</span></div>
    </div>
  </div>
  <div class="disclaimer-section mb-3">
        <div class="disclaimer-icon">
          <i class="fas fa-info-circle"></i>
        </div>
        <div class="disclaimer-content">
          <h3>Disclaimer</h3>
          <p>This is a request for quote only and does not constitute an order or a commitment to sell.</p>
          <p>Pricing, availability and lead times are subject to change.</p>
          <p>A sales representative will contact you with the quote details.</p>
        </div>
      </div>

  <div class="text-center">
    <button class="btn btn-primary" (click)="gotoQuotes()">View Quote Requests</button>
  </div>
</div>
